export const iconFontAwesomeEnergyFire = (
	<i className="fa-solid fa-fire"></i>
);
